import React, { useEffect, useRef, useState } from 'react';
import cx from 'clsx';

export const Accordion = ({ title, children, openOnMount = false }) => {
    const [isOpen, setIsOpen] = useState(openOnMount);

    const accordionRef = useRef(null);

    useEffect(() => {
        if (!accordionRef.current) return;
        const mountAccordion = () => {
            const Accordion = window.cbdceAccordion;
            if (!Accordion) return false;
            const accoridonInstance = new Accordion(accordionRef.current, false);
            if (openOnMount) {
                accoridonInstance.open(true);
            }
        };
        if (!mountAccordion()) {
            const interval = setInterval(() => {
                if (mountAccordion()) {
                    clearInterval(interval);
                }
            }, 300);
        }
    }, [accordionRef.current]);


    return (
        <details
            ref={accordionRef}
            className={cx(
                'cbdce-accordion',
                'cbdce-accordion--animated'
            )}
        >
            <summary className="cbdce-accordion__title">
                <h5 className="cbdce-accordion__title-text cbdce-accordion__title-text-medium">{title}</h5>
                <span className="cbdce-accordion__toggle">
                  <span className="fa fa-angle-down"></span>
                </span>
            </summary>
            <div className="cbdce-accordion__content">
                {children}
            </div>
        </details>
    );
};

export default Accordion;